import { Component, ComponentRef, Input, OnInit, Type, ViewContainerRef } from "@angular/core";
import { ComponentLoaderService } from "src/app/miscellaneous/component-loader.service";
import { IntroRedComponent } from "./models/intro-red/intro-red.component";
import { CardWrapperComponent } from "./models/card-wrapper/card-wrapper.component";
import { CardFilesComponent } from "./models/card-files/card-files.component";
import { DocumentPreviewComponent } from "./models/document-preview/document-preview.component";
import { InterceptorDataComponent } from "./models/interceptor-data/interceptor-data.component";
import { TimelineComponent } from "./models/timeline/timeline.component";
import { FileListComponent } from "./models/file-list/file-list.component";
import { ObbligoComponent } from "./models/obbligo/obbligo.component";
import { MiniCardFilesComponent } from "./models/mini-card-files/mini-card-files.component";
import { HeroComponent } from "./models/hero/hero.component";
import { HeroImageComponent } from "./hero-image/hero-image.component";
import { IconContainerComponent } from "./icon-container/icon-container.component";
import { CardResourceComponent } from "./models/card-resource/card-resource.component";
import { WebcontentPublisherComponent } from "./models/webcontent-publisher/webcontent-publisher.component";

@Component({
  selector: "app-template",
  templateUrl: "./template.component.html",
})
export class TemplateComponent implements OnInit {
  @Input() name!: string;
  @Input() data: any;

  public cRef: Array<ComponentRef<any>> = [];

  constructor(
    private vcr: ViewContainerRef,
    private cls: ComponentLoaderService
  ) { }

  ngOnInit(): void {
    const compRef: ComponentRef<any> = this.cls.loadComponent(
      this.vcr,
      this.componentTypeResolver(this.name),
      this.data
    );
    this.cRef.push(compRef);
  }

  componentTypeResolver(type: string | null): Type<any> {
    switch (type) {
      case "intro-red":
        return IntroRedComponent;
      case "card-wrapper":
        return CardWrapperComponent;
      case "card-files":
        return CardFilesComponent;
      case "document-preview":
        return DocumentPreviewComponent;
      case "interceptor-data":
        return InterceptorDataComponent;
      case "timeline":
        return TimelineComponent;
      case "file-list":
        return FileListComponent;
      case "obbligo":
        return ObbligoComponent;
      case "mini-card-files":
        return MiniCardFilesComponent;
      case "hero":
        return HeroComponent;
      case "hero-image":
        return HeroImageComponent;
      case "icon-container":
        return IconContainerComponent;
      case "card-resource":
        return CardResourceComponent;
      case "webcontent-publisher":
        return WebcontentPublisherComponent;
      default: {
        return IntroRedComponent;
      }
    }
  }

  ngOnDestroy() {
    this.cRef.forEach((e) => e.destroy());
  }
}
